import { Navigate } from "react-router-dom";
import UserLayout from "../layouts/UserLayout";
import GettingStarted from "./getting-started";
import Home from "./homeV2";
import Programs from "./program-introduction";
import Workouts from "./workout";
import Login from "./auth/login";
import SignUp from "./auth/signup/Signup";
import SignUpEmail from "./auth/signup";
import CompanyUserVerification from "./auth/company-signup-verification";
import ResetPassword from "./auth/reset";
import OnHold from "./auth/onhold";
import InActive from "./auth/inactive";
import PlusOne from "./plusone";
import Ambassador from "./ambassador";
import PatientInvite from "./patient-invite";
import Support from "./support";
import ProgramIntroduction from "./program-introduction";
import ProgramDetail from "./program-detail";
import PlanBilling from "./indi-plan/plan-billing";
import Renew from "./indi-plan/renew";
import Account from "./account";
import CancelSubscription from "./account/Components/CancelV2";
import Promo from "./indi-plan/promo";
import Challenge from "./challenge";
import Notification from "./settings/notification";
import VirtualPT from "./virtual-pt";
import IndiPlanSale from "./indi-plan/sale-plan";
import IndiPlanSaleExistingUser from "./indi-plan/sale-plan-existing-user";
import PersonalInfo from "./getting-started/components/PersonalInfo";
import UserOnboarding from "./user-onboarding";
import UserSurvey from "./user-survey";

export const PUBLIC_ROUTES = [
    {
        path: "/",
        element: <Login />,
    },
    // {
    //     path: "signup",
    //     element: <SignUp />,
    // },
    // {
    //     path: "signup/email",
    //     element: <SignUpEmail />,
    // },
    {
        path: "login",
        element: <Login />,
    },
    // {
    //     path: "signup",
    //     element: <SignUp />,
    // },
    {
        path: "reset-password",
        element: <ResetPassword />,
    },
    {
        path: "company-user-verification",
        element: <CompanyUserVerification />,
    },
    {
        path: "user-onboarding/:page",
        element: <UserOnboarding />,
    },
    {
        path: "*",
        element: <Navigate to="/user-onboarding/0" />,
    },
];

export const PRIVATE_ROUTES = [
    //Add your private routes here
    {
        path: "/",
        element: <UserLayout />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "home",
                element: <Home />,
            },

            {
                path: "programs",
                element: <Programs />,
            },
            {
                path: "workout",
                element: <Workouts />,
            },
            {
                path: "account",
                element: <Account />,
            },
            {
                path: "cancel-subscription",
                element: <CancelSubscription />,
            },
            {
                path: "plus-one",
                element: <PlusOne />,
            },
            {
                path: "patient-invite",
                element: <PatientInvite />,
            },
            {
                path: "indi-support",
                element: <Support />,
            },
            {
                path: "program-detail",
                element: <ProgramDetail />,
            },
            {
                path: "challenges",
                element: <Challenge />,
            },
            {
                path: "settings/notification",
                element: <Notification />,
            },
        ],
    },
    // {
    //   path: "signup",
    //   element: <SignUp />,
    // },
    // {
    //   path: "signup/email",
    //   element: <SignUpEmail />,
    // },
    {
        path: "choose-plan",
        element: <PlanBilling />,
    },
    {
        path: "choose-plan-sale",
        element: <IndiPlanSale />,
    },
    {
        path: "plan-sale",
        element: <IndiPlanSaleExistingUser />,
    },
    {
        path: "renew",
        element: <Renew />,
    },
    {
        path: "promo",
        element: <Promo />,
    },
    {
        path: "welcome",
        element: <OnHold />,
    },
    {
        path: "inactive",
        element: <InActive />,
    },
    {
        path: "getting-started",
        element: <GettingStarted />,
    },
    {
        path: "personal-info",
        element: <PersonalInfo />,
    },
    {
        path: "program-introduction",
        element: <ProgramIntroduction />,
    },
    {
        path: "virtual-pt",
        element: <VirtualPT />,
    },
    {
        path: "user-survey",
        element: <UserSurvey />,
    },
    {
        path: "*",
        element: <Navigate to="/" />,
    },
];
